
if (!customElements.get('lazy-load-section')) {
    class LazyLoadSection extends HTMLElement {
        constructor() {
            super();
            this.elements = {
              lazyLoadSection: this.querySelector('.lazyload-wrapper'),
              lazyLoadContent: this.querySelector(`#lazyload-${this.getAttribute('data-id')}`),
              videoUrl:  this.querySelector('.lazyload-wrapper').getAttribute('data-video-url')
            };
            let options = {
                root: null,
                rootMargin: "0px",
                threshold: 1.0,
            }
           this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);   
          }
    
          connectedCallback() {
            this.observer.observe(this);
          }
        
          disconnectedCallback() {
            this.observer.unobserve(this);
          }

          loadVideoClick () {
              const srcEmbed = this.elements.videoUrl;
              const modalVideo = document.querySelector('.modal__video');
              const wrapVideo = document.querySelector('.wrap__video iframe');
      
              function openVideoModal() {
                  modalVideo.style.display = 'flex';
                  wrapVideo.src = srcEmbed;
              }
      
              function closeVideoModal() {
                  modalVideo.style.display = 'none';
                  wrapVideo.src = '';
              }
      
              document.querySelector("#tutorial-video img").addEventListener('click', openVideoModal);
              document.querySelector("#tutorial-video span").addEventListener('click', openVideoModal);
              document.querySelector(".modal__bg").addEventListener('click', closeVideoModal);
              document.querySelector(".video__close").addEventListener('click', closeVideoModal);
          }
        
          loadFeaturedScript() {
            this.elements.lazyLoadSection.innerHTML = JSON.parse(this.elements.lazyLoadContent.getAttribute('section-content'));
          }
        
          handleIntersection(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    console.log(entry.rootBounds + 'loaded');
                    this.loadFeaturedScript();
                    this.disconnectedCallback();
                    if(this.elements.videoUrl){
                      this.loadVideoClick();
                    }
                  }
            })
          }

        }
        customElements.define('lazy-load-section', LazyLoadSection);
}   